export default "# FileViewer 文件预览\r\n\r\n用于预览、下载文件。\r\n\r\n提供统一的文件链接操作。\r\n\r\n## 何时使用\r\n\r\n- ...。";